import React from 'react';

import initialMetricsPublisher from '../metrics';

interface PropsType {
  children: JSX.Element
}

export class AppInitWrapper extends React.Component<PropsType, {}> {
    private errorBoundaryMetricsPublisher = initialMetricsPublisher.newChildActionPublisherForMethod('ErrorBoundary')

    componentDidCatch(error: Error, info: React.ErrorInfo) {
        this.errorBoundaryMetricsPublisher.publishCounterMonitor('ErrorBoundary.Encounter', 1);
        // In your application you may want to update the UI; here we will re-throw and fail the whole app, after logging
        throw error;
    }

    render() {
        return this.props.children;
    }

}

export default AppInitWrapper;
